import { TeamMembersRepository, type TeamMemberFilters } from "@/repositories/team-members.repository.ts";
import type { InviteSent } from "@shyne/shared/api";
import { InvitePayload } from "./teammembers.entity";

export async function listTeamMembers(page: number, pageSize: number, filters: TeamMemberFilters) {
  return TeamMembersRepository.list(page, pageSize, filters);
}

export async function sendTeamMemberInvite(payload: InvitePayload): Promise<InviteSent> {
  return TeamMembersRepository.invite(payload.name, payload.email, payload.role);
}
